<div>
  <a href="javascript:void(0)" (click)="onLinkClick()">
    {{params.value}}
  </a>
</div>